// Track GA events
function trackGA(eventName, params = {}) {
    if (!window.gtag) return;

    window.gtag('event', eventName, {
        ...params
    });
}

function getSectionTrackingContext(node) {
    const section = node.closest('[data-section-id]');
    if (!section) return null;

    const parentSection = section.closest('[id*="shopify-section-template"]');
    if (!parentSection) return null;

    const sectionList = [...document.querySelectorAll('[id*="shopify-section-template"]')];
    const position = sectionList.findIndex(el => el === parentSection) + 1;
    const sectionType =
      section.dataset.sectionType ||
      section.closest('[data-section-type]')?.dataset.sectionType ||
      '';
    const pageTemplate = document.body?.dataset?.template || 'unknown';

    return {
        pageTemplate,
        section,
        sectionType,
        position
    };
}

// Track card clicks
document.addEventListener('click', (e) => {
    const card = e.target.closest('[data-track="card-click"]');
    if (!card) return;

    const trackingContext = getSectionTrackingContext(card);
    if (!trackingContext) return;

    trackGA('section_click', {
        page_template: trackingContext.pageTemplate,
        section_id: trackingContext.section.dataset.sectionId,
        section_type: trackingContext.sectionType,
        section_position: trackingContext.position,
        element_type: 'card',
        card_index: card.dataset.cardIndex,
        card_type: card.dataset.cardType,
        destination_url: card.dataset.destination
    });
});

// Track in-section link clicks
document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-track="section-link-click"]');
    if (!link) return;

    const trackingContext = getSectionTrackingContext(link);
    if (!trackingContext) return;

    trackGA('section_click', {
        page_template: trackingContext.pageTemplate,
        section_id: trackingContext.section.dataset.sectionId,
        section_type: trackingContext.sectionType,
        section_position: trackingContext.position,
        element_type: 'link',
        link_type: link.dataset.linkType,
        link_text: link.dataset.linkText,
        destination_url: link.dataset.destination
    });
});
